import React, { useState, memo, useRef, useCallback } from 'react';
// import TextContainer, {generateEmptyItem} from "@components/textContainer/TextContainer";
import TextContainerModal from '@components/textContainerModal/TextContainerModal';
import useTextContainerService from '@hooks/useTextContainerService';

function TextContainerInlineInput(props) {
  const {
    value,
    onChange,
    isTemplate,
    onProjectCreating,
    data: formData,
    formChange = () => {},
  } = props; // we store text container id as value prop
  const [modalVisible, setModalVisible] = useState(false);
  const { saveData, data, loading } = useTextContainerService(
    value,
    isTemplate,
  );
  const textContainerRef = useRef();

  const onOk = useCallback(() => {
    if (textContainerRef.current) {
      const dataToSend = textContainerRef.current.getData();
      if (dataToSend) {
        saveData({
          data: dataToSend,
          id: onProjectCreating ? undefined : data?.id,
        })
          .then((result) => {
            // if (result?.id && result?.id !== value) {
            //   saveLink(section, result.id);
            //   setLink(result.id);
            // }
            // if (textContainerRef.current?.setData && result.data) {
            //   textContainerRef.current.setData(result.data);
            // }
            setModalVisible(false);
            onChange(result?.id);
            formChange();
          })
          .catch(console.log);
      }
    }
  }, [value, data, onChange]);
  const onCancel = useCallback(() => {
    setModalVisible(false);
    // eslint-disable-next-line no-unused-expressions
    textContainerRef.current?.setData?.(
      data?.data?.contents || [],
      data?.data?.columnsWidthRatio || [],
    );
    // textContainerRef.current?.setData?.(
    //   data?.data?.length ? data.data : [generateEmptyItem()],
    // );
  }, [data]);

  return (
    <>
      <div
        className="upload-pdf-text"
        onClick={() => {
          setModalVisible(true);
        }}
      >
        Edit Text Container
      </div>
      <TextContainerModal
        visible={modalVisible}
        ref={textContainerRef}
        onOk={onOk}
        onCancel={onCancel}
        loading={loading}
        initialValues={data?.data.contents}
        initialColumnRatio={data?.data.columnsWidthRatio}
        ratio={formData?.ratio}
      />
    </>
  );
}

export default memo(TextContainerInlineInput);
